import { onMount } from "solid-js";

import { isMobile } from "@/lib/isMobile";
import { isLogin } from "@/stores/userStore";

// interface RouterType {
//   preload?: () => Promise<{ default: any }>
// }

interface RouterType {
  preload?: () => Promise<{ default: unknown }>;
}

interface PreloadType {
  isOnlyMobile?: boolean;
  logins?: "1" | "2" | undefined; // 登陆预加载，未登录预加载，默认全部预预加载
  // 路由
  router?: RouterType;
}

interface PreloadAllType {
  timmer?: number; // 定时器
  preloads?: Array<PreloadType | RouterType>; // 路由列表
}

const defaultDefault: PreloadType = {
  isOnlyMobile: true, // 仅h5预加载
};
export const usePreload = (options: PreloadAllType = {}) => {
  // 临时缓存数据
  let preloads: Array<PreloadType> = [];

  const isValidaPreload = (options: PreloadType = {}) => {
    const preloadOptions = Object.assign({}, defaultDefault, options);
    if (preloadOptions.isOnlyMobile === true && !isMobile()) {
      return false;
    }

    if (
      preloadOptions.logins !== undefined &&
      preloadOptions.logins === "1" &&
      isLogin()
    ) {
      return false;
    }

    return true;
  };

  const toPreload = async (index = 0) => {
    const currentPreload: PreloadType = preloads[index];
    if (currentPreload) {
      if (isValidaPreload(currentPreload)) {
        try {
          await currentPreload?.router?.preload?.();
        } catch (error) {
          // 预加载失败时记录错误，但不中断后续预加载
          console.warn(`[usePreload] 预加载模块失败 (index: ${index}):`, error);
        }
      }
      // 无论成功或失败，都继续预加载下一个模块
      toPreload(index + 1);
    } else {
      preloads = [];
    }
  };

  const isPreloadType = (obj: PreloadType | RouterType): obj is PreloadType => {
    return (obj as PreloadType).router !== undefined;
  };

  const preload = async (preloadOptions: PreloadType | RouterType) => {
    if (isPreloadType(preloadOptions)) {
      preloads.push(preloadOptions);
    } else {
      preloads.push({ router: preloadOptions });
    }
    setTimeout(() => toPreload(), options?.timmer ?? 300);
  };

  const preloadAll = async (preloadList: Array<PreloadType | RouterType>) => {
    // 先收集所有需要预加载的模块
    preloadList.forEach((preloadOptions) => {
      if (isPreloadType(preloadOptions)) {
        preloads.push(preloadOptions);
      } else {
        preloads.push({ router: preloadOptions });
      }
    });
    // 统一延迟后开始预加载，避免多个 setTimeout 并发
    setTimeout(() => toPreload(), options?.timmer ?? 300);
  };

  onMount(() => {
    if (options.preloads?.length) {
      preloadAll(options.preloads);
    }
  });

  return {
    preload,
    preloadAll,
  };
};
